export function createMapStorage<T>(storage: Storage = localStorage) {
  return {
    getItem: (key: string): Map<string, T> => {
      const storedValue = storage.getItem(key);
      if (!storedValue) {
        return new Map();
      }
      return new Map(JSON.parse(storedValue));
    },
    setItem: (key: string, newValue: Map<string, T>) => {
      storage.setItem(key, JSON.stringify([...newValue.entries()]));
    },
    removeItem: (key: string) => {
      storage.removeItem(key);
    },
  };
}
